/* eslint-disable no-magic-numbers */
import React from 'react';

export const ArrowIcon = (): React.ReactElement => <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
>
    <path d="M5 12h14M13 6l6 6-6 6"/>
</svg>;

export const EsportsIcon = (): React.ReactElement => <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fe9400"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
>
    <rect x="2" y="7" width="20" height="11" rx="5"/>
    <path d="M7 11v3M5.5 12.5h3"/>
    <circle cx="16" cy="11.5" r=".8"/>
    <circle cx="18" cy="13.5" r=".8"/>
</svg>;

export const CasinoIcon = (): React.ReactElement => <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fe9400"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
>
    <rect x="3" y="3" width="18" height="18" rx="3"/>
    <circle cx="8" cy="8" r="1.2"/>
    <circle cx="16" cy="8" r="1.2"/>
    <circle cx="12" cy="12" r="1.2"/>
    <circle cx="8" cy="16" r="1.2"/>
    <circle cx="16" cy="16" r="1.2"/>
</svg>;

export const RevshareIcon = (): React.ReactElement => <svg
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fe9400"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
>
    <path d="M17 2l4 4-4 4"/>
    <path d="M3 11v-1a4 4 0 0 1 4-4h14"/>
    <path d="M7 22l-4-4 4-4"/>
    <path d="M21 13v1a4 4 0 0 1-4 4H3"/>
</svg>;

export const StatsIcon = (): React.ReactElement => <svg
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fe9400"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
>
    <path d="M3 20h18"/>
    <path d="M6 16v-5M11 16V6M16 16v-8M21 16v-3"/>
</svg>;

export const GrowthIcon = (): React.ReactElement => <svg
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fe9400"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
>
    <path d="M12 3l2.6 5.6 6 .7-4.5 4.1 1.2 6L12 16.4 6.7 19.4l1.2-6L3.4 9.3l6-.7z"/>
</svg>;

export const CryptoIcon = (): React.ReactElement => <svg
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fe9400"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
>
    <circle cx="12" cy="12" r="9"/>
    <path d="M9.5 8h4a2 2 0 0 1 0 4h-4zM9.5 12h4.5a2 2 0 0 1 0 4H9.5zM9.5 8v8M11 6.5V8M11 16v1.5"/>
</svg>;

export const TelegramIcon = (): React.ReactElement => <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fe9400"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
>
    <path d="M21.5 3.5L2.5 11l6.5 2.5L11.5 20l3.5-5 5 3.5z"/>
    <path d="M9 13.5l12.5-10"/>
</svg>;
